import GoalsSummaryModule from "./goalsSummaryModule";
import GoalsSummarySagas from "./redux/goalsSummarySagas";
import GoalsSummaryReducer from "./redux/goalsSummaryReducer";

export default {
  Component: GoalsSummaryModule,
  moduleName: "goalsSummary",
  saga: GoalsSummarySagas(),
  reducer: GoalsSummaryReducer
};
